<template>
  <!-- 对话框 -->
  <el-dialog title="添加城市小组信息" width="40%" top="2vh" :visible.sync="show" :before-close="closeDialog"
    :close-on-click-modal="false">
    <div style="height: 40vh ;overflow: auto;">

      <div class="form-box">
        <el-form ref="form" :model="submit_data">


          <el-form-item label="城市小组" label-width="125px">
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder">
            </el-input>
          </el-form-item>
          <el-form-item label="备注" label-width="125px">
            <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" :maxlength=13>
            </el-input>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="false"></submitBtn>
      <el-button @click="closeDialog">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
  var _this, district
  export default {
    props: {
      'isShow': Boolean,
      'data': {}
    },

    watch: {


      data(newData, oldData) {
        console.log(newData, oldData)
        this.city_array = newData

      },


      isShow(newData, oldData) {
        _this.show = true;


      },
    },
    data() {
      return {
        show: false,


        submit_url:'/city/addCityGroupSubmit',
        // 表单数据
        submit_data: {
          name: '',
          remarks:'',
        },
        submit_rules: {
          remarks: {
            placeholder: '请添加备注 ，100字节之间',
            rules: {
              required: true,
              message: '请添加备注 ，100字节之间',
              regulation: 'between',
              rulesData: 30
            }
          },
          name: {
            placeholder: '城市名称100字节之内',
            rules: {
              required: true,
              message: '城市名称100字节之内',
              regulation: 'elt_str',
              rulesData: 30
            }
          },

        },

      };
    },
    created() {
      _this = this;
      this.submit_data.name = ''
    },

    methods: {



      // 提交
      onSubmitDig() {



            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');

            _this.closeDialog()


      },
      closeDialog() {
        _this.show = false;

        _this.submit_data.name = ''
        for (const key in _this.submit_data) {
          _this.submit_data[key] = ''
        }
      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 35%;
    float: left;
  }

  .form-box {
    width: 90%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
</style>